import React, { useRef } from "react";
import { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./userCadastro.css";
import Header from "../../components/header/header";
import CustomModal from "../../components/modal/Modal";
import InputMask from "react-input-mask";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSave,
  faWindowClose,
  faEye,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons"; // Importe os ícones de olho e olho cortado
import {
  getUserById,
  getUserUpdate,
  getUsersCadastro,
} from "../../services/api_cadastro_users";
import { getPerfil } from "../../services/api_perfil";
import { getPessoas } from "../../services/api_pessoas";
import { getUnidades } from "../../services/api_unidades";
import Swal from "sweetalert2";
import Spinner from "react-bootstrap/Spinner";
import POLLING_INTERVAL from "../../hooks/Interval/interval";

const UserRegister = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.state?.id;
  //console.log(id);

  const [name, setNome] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [id_pessoa, setPessoa] = useState("");
  const [id_perfil, setPerfil] = useState("");
  const [id_unidade, setUnidade] = useState("");
  const [unidades, setUnidades] = useState([]);
  const [perfil, setPerfis] = useState([]);
  const [pessoas, setPessoas] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [showPassword, setShowPassword] = useState(false); // Adicione o estado para controlar a visibilidade da senha
  const [isSaving, setSaving] = useState(false)

  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({});

  const inputRefs = {
    Nome: useRef(null),
    Senha: useRef(null),
    Email: useRef(null),
    Pessoa: useRef(null),
    Unidade: useRef(null),
    Perfil: useRef(null)
  };

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await getUserById(id);
        //console.log(response);
        const user = response.data.User; // Corrigido para acessar response.data.empresa
        if (user) {
          setNome(user.name || "");
          setEmail(user.email || "");
          setPassword(user.password || "");
          setPessoa(user.id_pessoa || "");
          setPerfil(user.id_perfil || "");
          setUnidade(user.id_unidade || "");
        } else {
          console.error("Dados não encontrados na resposta:", response);
        }
      } catch (error) {
        console.error("Erro ao obter dados:", error);
      }
    };

    if (id) {
      fetchUser();
    }
  }, [id]);

  useEffect(() => {
    const fetchPessoa = async () => {
      try {
        const response = await getPessoas();
        //console.log(response)

          if (response) {
          const pessoasAtivas = response.data.pessoas.filter(
            (pessoa) => pessoa.deleted_at=== null
          )
          setPessoas(pessoasAtivas);
          setLoading(false);
        } else {
          console.error("A resposta da API não é uma array:");
        }
        //console.log(response)
      } catch (error) {
        console.error("Erro ao obter empresas:", error);
      }
    };

    fetchPessoa();
    const interval = setInterval(()=>{
      fetchPessoa()
    }, POLLING_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchPerfil = async () => {
      try {
        const response = await getPerfil();
        //console.log(response)

        if (response) {
          const perfisAtivos = response.data.perfil.filter(
            (perfis) => perfis.deleted_at === null
          )
          setPerfis(perfisAtivos);
          setLoading(false);
        } else {
          console.error("A resposta da API não é uma array:");
        }
        //console.log(response)
      } catch (error) {
        console.error("Erro ao obter empresas:", error);
      }
    };

    fetchPerfil();
  }, []);

  useEffect(() => {
    const fetchUnidades = async () => {
      try {
        const response = await getUnidades();
        //console.log(response)

        if (response) {
          const unidadesAtivas = response.data.unidades.filter(
            (unidade) => unidade.deleted_at === null
          )
          setUnidades(unidadesAtivas);
          setLoading(false);
        } else {
          console.error("A resposta da API não é uma array:");
        }
        //console.log(response)
      } catch (error) {
        console.error("Erro ao obter empresas:", error);
      }
    };

    fetchUnidades();
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleOpenModal = (title, body) => {
    setModalContent({ title, body });
    setShowModal(true);
  };

  const validarInputs = () => {
    if (id) {
      if (!name || !email) {
        Swal.fire({
          icon: "warning",
          title: "Oops!",
          text: "Os campos Nome e E-mail não podem ficar vazios.",
        });

        return false;
      }

      return true;
    } else {
      if (!name || !password || !email || !unidades|| !pessoas) {
        Swal.fire({
          icon: "warning",
          title: "Oops!",
          text: "O preenchimento dos campos: 'Nome, E-mail, Unidade, Pessoa e Senha', é obrigatório.",
        });

        return false;
      }
      return true;
    }
  };

  const addCadastro = async (body) => {
    try {
      const response = await getUsersCadastro(body);

      if (response && response.status === 200) {
        regret();
      } else {
        console.error("Erro ao cadastrar unidade:", response);
      }
    } catch (error) {
      console.error("Erro ao cadastrar unidade:", error);
    }finally {
      setSaving(false); // Desativa o spinner após o salvamento
    }
  };

  const newUpdate = async (body) => {
    try {
      const response = await getUserUpdate(id, body);

      if (response && response.status === 200) {
        regret();
      } else {
        console.error("Erro ao cadastrar unidade:", response);
      }
    } catch (error) {
      if (error.response && error.response.status === 422) {
        handleOpenModal(
          "Erro de validação",
          "Houve um erro na validação dos dados."
        );
      } else if (error.response && error.response.status === 500) {
        handleOpenModal(
          "Erro interno do servidor",
          "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde."
        );
      } else {
        console.error("Erro ao atualizar a empresa:", error);
        handleOpenModal(
          "Erro ao atualizar a empresa",
          "Por favor, tente novamente mais tarde."
        );
      }
    }finally {
      setSaving(false); // Desativa o spinner após o salvamento
    }
  };

  const handleSalvar = async () => {
    if (validarInputs()) {
      setSaving(true)
      let body = {
        name,
        email,
        password,
        id_perfil,
        id_pessoa,
        id_unidade,
      };
      if (id) {
        !password && delete body.password;
        newUpdate(body);
      } else {
        addCadastro(body);
      }
    }
  };

  const handleCaracteres = (e) => {
    const value = e.target.value;
    if (value.length <= 30) {
      setNome(value);
    } else {
      Swal.fire({
        icon: "warning",
        title: "Oops!",
        text: "O campo não pode ultrapassar 30 caracteres",
      });
    }
  };

  const handleEmail = (e) => {
    const value = e.target.value;
    if (value.length <= 50) {
      setEmail(value);
    } else {
      Swal.fire({
        icon: "warning",
        title: "Oops!",
        text: "O campo E-mail não pode ultrapassar 50 caracteres",
      });
    }
  };
  const handlePassword = (e) => {
    const value = e.target.value;
    if (value.length <= 12) {
      setPassword(value);
    } else {
      Swal.fire({
        icon: "warning",
        title: "Oops!",
        text: "O campo Senha não pode ultrapassar 12 caracteres",
      });
    }
  };

  const handleKeyDown = (e, nextFieldRef) => {
    if (e.key === 'Enter' && nextFieldRef.current) {
      e.preventDefault();
      const elementToFocus = nextFieldRef.current.inputRef || nextFieldRef.current;
  
      if (typeof elementToFocus.focus === 'function') {
        elementToFocus.focus();
      } else {
        console.warn('O elemento de input não tem o método focus.');
      }
    }
  };
  

  const regret = () => {
    window.history.back();
  };

  return (
    <>
      <Header title="Cadastros / Listagem de Usuários Cadastrados / Cadastro de Usuário" />
      <div className="content-wrapper pl-5 pr-5 pt-2">
        {isLoading ? (
          <div className="center-btn">
            <h5 className="mb-5">Carregando dados</h5>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <Form>
            <Row>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formNome">
                  <Form.Label>Nome</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Digite o nome"
                    value={name}
                    onChange={handleCaracteres}
                    ref={inputRefs.Nome}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.Email)}
                  />
                </Form.Group>
              </Col>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formEmail">
                  <Form.Label>E-mail</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Digite o e-mail"
                    value={email}
                    onChange={handleEmail}
                    ref={inputRefs.Email}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.Senha)}
                  />
                </Form.Group>
              </Col>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formSenha">
                  <Form.Label>Senha</Form.Label>
                  <div className="input-group">
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      placeholder="Digite a Senha"
                      value={password}
                      onChange={handlePassword}
                      ref={inputRefs.Senha}
                      onKeyDown={(e) => handleKeyDown(e, inputRefs.Pessoa)}
                    />
                    <Button
                      variant="outline-secondary"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      <FontAwesomeIcon
                        icon={showPassword ? faEyeSlash : faEye}
                      />{" "}
                    </Button>
                  </div>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formPessoa">
                  <Form.Label>Pessoa</Form.Label>
                  <Form.Control
                    as="select"
                    value={id_pessoa}
                    onChange={(e) => setPessoa(e.target.value)}
                    ref={inputRefs.Pessoa}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.Perfil)}
                  >
                    <option value="">Selecione</option>
                    {pessoas &&
                      pessoas.map((id_pessoa) => (
                        <option key={id_pessoa.id} value={id_pessoa.id}>
                          {id_pessoa.nome}
                        </option>
                      ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formPerfil">
                  <Form.Label>Perfil</Form.Label>
                  <Form.Control
                    as="select"
                    value={id_perfil}
                    onChange={(e) => setPerfil(e.target.value)}
                    ref={inputRefs.Perfil}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.Unidade)}
                  >
                    <option value="">Selecione</option>
                    {perfil &&
                      perfil.map((id_perfil) => (
                        <option key={id_perfil.id} value={id_perfil.id}>
                          {id_perfil.nome}
                        </option>
                      ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formUnidades">
                  <Form.Label>Unidade</Form.Label>
                  <Form.Control
                    as="select"
                    value={id_unidade}
                    onChange={(e) => setUnidade(e.target.value)}
                    ref={inputRefs.Unidade}
                  >
                    <option value="">Selecione</option>
                    {unidades &&
                      unidades.map((id_unidade) => (
                        <option key={id_unidade.id} value={id_unidade.id}>
                          {id_unidade.nome}
                        </option>
                      ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>

            <div className="center-two-btn d-flex justify-content-center ">
              <Button
                className="border border-dark text-dark m-2 mt-4"
                variant="light"
                onClick={handleSalvar}
                disabled = {isSaving}
              >
                {isSaving ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  <FontAwesomeIcon icon={faSave} />
                )}
              </Button>
              <Button
                className="border border-dark text-dark m-2 mt-4"
                variant="light"
                onClick={regret}
              >
                <FontAwesomeIcon icon={faWindowClose} />
              </Button>
            </div>
          </Form>
        )}
      </div>

      <CustomModal
        show={showModal}
        handleClose={handleCloseModal}
        title={modalContent.title}
        body={modalContent.body}
      />
    </>
  );
};

export default UserRegister;
